/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { useAuthState } from 'shared-ui/auth';
import { MobileMenuAccountPanel } from './MobileMenuAccountPanel';
import type { MenuAccountItemsType } from './Navbar.types';

interface MobileMenuSignInOrAccountPanelProps {
    menuAccountItems: MenuAccountItemsType;
    isGuestAllowed?: boolean;
    isGuest: boolean;
}

export function MobileMenuSignInOrAccountPanel({
    menuAccountItems,
    isGuestAllowed,
    isGuest,
}: MobileMenuSignInOrAccountPanelProps) {
    // Redux state
    const { isCommercial, isRegisteredUserOrGuest } = useAuthState();

    return (
        <MobileMenuAccountPanel
            isCommercialAccount={isCommercial}
            hideBottomSignOut
            menuAccountItems={menuAccountItems}
            isGuest={isGuest}
            isLogged={isRegisteredUserOrGuest}
            isGuestAllowed={isGuestAllowed}
        />
    );
}
